import type { ProcurementQueueItem, RequestItemPriority } from '../../shared/api/types'

export const PRIORITY_LABELS: Record<RequestItemPriority, string> = {
  HIGH: 'Высокий',
  MEDIUM: 'Средний',
  LOW: 'Низкий',
}

export function formatDeadline(iso: string | null): string {
  if (!iso) return ''
  return new Date(iso).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })
}

export interface QueueRow {
  id: string
  categoryLabel: string
  clientCode: string
  requestNumber: string
  partNumber: string
  brand: string
  noteForProcurement: string
  qtyLabel: string
  priorityLabel: string
  deadlineLabel: string
  statusLabel: string
  assigneeLabel: string
  managerLabel: string
  _raw: ProcurementQueueItem
}

/** Совпадение строки с поисковым запросом — повторяет поведение AG Grid
 *  quickFilter: разбиваем запрос по пробелам, каждый токен должен встретиться
 *  в склеенных строковых полях. Используется в ProcurementQueuePage для
 *  отдельного подсчёта совпадений по активным и обработанным позициям. */
export function matchesQueueRow(row: QueueRow, q: string): boolean {
  const trimmed = q.trim()
  if (!trimmed) return true
  const haystack = [
    row.partNumber,
    row.brand,
    row.clientCode,
    row.requestNumber,
    row.noteForProcurement,
    row.categoryLabel,
    row.qtyLabel,
    row.priorityLabel,
    row.deadlineLabel,
    row.statusLabel,
    row.assigneeLabel,
    row.managerLabel,
  ]
    .join(' ')
    .toLowerCase()
  return trimmed
    .toLowerCase()
    .split(/\s+/)
    .every((tok) => haystack.includes(tok))
}
